import { ValidationError } from "./exceptions";
import t                   from "@/i18n/translator";

export function isNumeric(val) {
    if (val && !/^\d+$/g.test(val)) {
        throw new ValidationError(t("numeric"));
    }
}

export function isPositive(val) {
    if (typeof val === "number" && val < 0) {
        throw new ValidationError(t("positive"));
    }
}

export function isString(val) {
    if (val && typeof val !== "string") {
        throw new ValidationError(t("alpha"));
    }
}

export function isEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (email && !re.test(String(email).toLowerCase())) {
        throw new ValidationError(t("invalid_email"));
    }
}

export function isCreditCardNumber(val) {
    if (val && (val.length !== 16 || !/^\d+$/g.test(val))) {
        throw new ValidationError(t("card_number"));
    }
}

export function isExpirationDate(val) {
    if (!val) {
        return;
    }
    if (!/\d{2}\/\d{4}/g.test(val)) {
        throw new ValidationError(t("invalid_date"));
    }
    const [month, year] = val.split("/").map(Number);
    const now = new Date();
    if (month > 12 ||
        month < 1 ||
        year > now.getFullYear() + 10
    ) {
        throw new ValidationError(t("invalid_date"));
    }
    if (
        year < now.getFullYear() ||
        (year === now.getFullYear() && month <= now.getMonth() + 1)
    ) {
        throw new ValidationError(t("card_expired"));
    }
}